import { createContext, useContext } from 'react';
import type { TypeaheadRootProps } from './Typeahead';

type TypeaheadContext = {
  size: TypeaheadRootProps['size'];
};

export const TypeaheadContext = createContext<TypeaheadContext | undefined>(
  undefined
);

export const useTypeaheadContext = () => {
  const context = useContext(TypeaheadContext);
  if (context === undefined) {
    throw new Error(
      'useTypeaheadContext must be used within a TypeaheadContext (which is available by using Typeahead)'
    );
  }
  return context;
};
